import { CKRadioGroup, CKRadioNext } from 'clearkit';

type ContactLeadsToggleProps = {
  value: string;
  onChange: (value: string) => void;
};

export const SalesforceContactLeadsToggle = ({
  value,
  onChange,
}: ContactLeadsToggleProps) => {
  const radioBoxClasses = 'ck-box py-4 px-6 items-start';
  return (
    <section>
      <h2 className="mb-1 font-medium">Contacts or leads</h2>
      <p className="mb-4 text-sm text-gray-600">
        Choose whether to create Salesforce contacts or leads from the list of
        prospected people. If a record already exists in Salesforce, we will
        automatically prevent a duplicate from being created.
      </p>
      <CKRadioGroup
        containerClassName="grid grid-cols-[repeat(auto-fit_,minmax(10rem,1fr))] gap-6"
        onChange={onChange}
        value={value}
      >
        <CKRadioNext className={radioBoxClasses} value="contact">
          Capture prospects as Salesforce contacts
        </CKRadioNext>
        <CKRadioNext className={radioBoxClasses} value="lead">
          Capture prospects as Salesforce leads
        </CKRadioNext>
      </CKRadioGroup>
    </section>
  );
};
